import * as R from 'ramda';
//////////////////////////////////////////////////

const isRecord = (value) => R.type(value) === 'Object';

const hasChangedSharedFields = (baseline, server, ignoredFields = []) => {
  const sharedFields = Object.keys(baseline || {}).filter((key) => (
    !ignoredFields.includes(key) && Object.prototype.hasOwnProperty.call(server || {}, key)
  ));

  return !R.equals(R.pick(sharedFields, baseline), R.pick(sharedFields, server));
};

export const hasServerTripChanges = (baselineTel, serverTel) => {
  if (!baselineTel || !serverTel) return true;

  if (hasChangedSharedFields(baselineTel, serverTel, [
    'events', 'isNew', 'loadName', 'order', 'originalRouteGuid', 'originalRouteName',
  ])) return true;

  const baselineEvents = baselineTel.events || {};
  const serverEvents = serverTel.events || {};
  const baselineGuids = Object.keys(baselineEvents).sort();
  const serverGuids = Object.keys(serverEvents).sort();

  if (!R.equals(baselineGuids, serverGuids)) return true;

  return serverGuids.some((guid) => hasChangedSharedFields(
    baselineEvents[guid],
    serverEvents[guid],
    ['isNew', 'originalRouteGuid'],
  ));
};

export const mergeServerChangesWithLocalEdits = (baseline, local, server) => {
  if (R.equals(local, baseline)) return server;

  if (R.equals(server, baseline)) return local;

  if (!isRecord(baseline) || !isRecord(local) || !isRecord(server)) return local;

  const keys = new Set([
    ...Object.keys(baseline),
    ...Object.keys(local),
    ...Object.keys(server),
  ]);

  return Array.from(keys).reduce((merged, key) => {
    const value = mergeServerChangesWithLocalEdits(baseline[key], local[key], server[key]);

    if (value === undefined) return merged;

    return { ...merged, [key]: value };
  }, {});
};

export const mergeServerEntries = (baseline, local, server) => Object.entries(server).reduce(
  (merged, [key, value]) => ({
    ...merged,
    [key]: mergeServerChangesWithLocalEdits(baseline[key], local[key], value),
  }),
  local,
);
